import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyAbs',
})
export class AbsPipe implements PipeTransform {
    transform(value: number | undefined): number | undefined {
        return value == null ? undefined : Math.abs(value);
    }
}
